'use strict'

import Vue from 'vue'
import store from '../store'
import axios from 'axios'

Vue.mixin({
  methods: {
    XbortGetRequest: function (path, params, callback) {
      path = path || ''
      // Axios base settings
      let headers = null
      let token = store.state.login.account.token
      if (token) {
        headers = {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      } else {
        headers = {
          'Content-Type': 'application/json'
        }
      }
      axios({
        headers: headers,
        url: path,
        method: 'get',
        params: params
      }).then(getResponse => {
        let getResult = {}
        if (getResponse.data) {
          getResult = {
            result: true,
            data: JSON.parse(getResponse.data.data)
          }
        } else {
          getResult = {
            result: false,
            data: null
          }
        }
        callback(getResult)
      }).catch(getError => {
        let errorResult = {}
        if (getError.response) {
          let errorResponse = JSON.parse(getError.response.data.message)
          errorResult = {
            result: false,
            data: errorResponse.message
          }
          if (errorResponse.code && errorResponse.code === '[MSCIND3015]') {
            this.$store.dispatch('clearAccount')
            this.errorMessage(errorResult)
          } else {
            callback(errorResult)
          }
        }
      })
    },
    XbortGetMedia: function (file, size) {
      size = `&size=${size}` || ''
      if (file) {
        return `${store.state.config.XbUrl}/${store.state.config.XbPath}/${store.state.config.XbUser}/${store.state.config.XbProject}/?appid=${store.state.config.XbAppID}&type=media${size}&request=${file}`
      } else {
        return `https://api.adorable.io/avatars/200/${store.state.login.account.email}.png`
      }
    },
    XbortGetUserImage: function (users, author, size) {
      size = `&size=${size}` || ''
      let image = ''
      users.forEach(user => {
        if (user.userId === author) {
          if (user.userImage) {
            image = `${store.state.config.XbUrl}/${store.state.config.XbPath}/${store.state.config.XbUser}/${store.state.config.XbProject}/?appid=${store.state.config.XbAppID}&type=media${size}&request=${user.userImage}`
          } else {
            image = `https://api.adorable.io/avatars/200/${user.userEmail}.png`
          }
        }
      })
      return image
    },
    XbortGetUserName: function (users, author) {
      let name = ''
      users.forEach(user => {
        if (user.userId === author) {
          if (user.userName) {
            name = user.userName
          } else {
            name = user.userEmail
          }
        }
      })
      return name
    },
    XbortRequest: function (path, method, params, callback) {
      path = path || ''
      // Axios base settings
      let headers = null
      let token = store.state.login.account.token
      if (token) {
        headers = {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      } else {
        headers = {
          'Content-Type': 'application/json'
        }
      }
      axios({
        headers: headers,
        url: path,
        method: method,
        data: params
      }).then(postResponse => {
        let postResult = {}
        if (postResponse.data) {
          postResult = {
            result: true,
            data: JSON.parse(postResponse.data.data)
          }
        } else {
          postResult = {
            result: false,
            data: null
          }
        }
        callback(postResult)
      }).catch(postError => {
        let errorResult = {}
        if (postError.response) {
          let errorResponse = JSON.parse(postError.response.data.message)
          console.log(postError.response.data)
          errorResult = {
            result: false,
            data: errorResponse.message
          }
          if (errorResponse.code && errorResponse.code === '[MSCIND3015]') {
            this.$store.dispatch('clearAccount')
            this.errorMessage(errorResult)
          } else {
            callback(errorResult)
          }
        }
      })
    },
    XbortDeleteRequest: function (path, params, callback) {
      path = path || ''
      // Axios base settings
      let headers = null
      let token = store.state.login.account.token
      if (token) {
        headers = {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      } else {
        headers = {
          'Content-Type': 'application/json'
        }
      }
      axios({
        headers: headers,
        url: path,
        method: 'delete',
        params: params
      }).then(getResponse => {
        let getResult = {}
        if (getResponse.data) {
          getResult = {
            result: true,
            data: JSON.parse(getResponse.data.data)
          }
        } else {
          getResult = {
            result: false,
            data: null
          }
        }
        callback(getResult)
      }).catch(getError => {
        let errorResult = {}
        if (getError.response) {
          let errorResponse = JSON.parse(getError.response.data.message)
          errorResult = {
            result: false,
            data: errorResponse.message
          }
          if (errorResponse.code && errorResponse.code === '[MSCIND3015]') {
            this.$store.dispatch('clearAccount')
            this.errorMessage(errorResult)
          } else {
            callback(errorResult)
          }
        }
      })
    }
  }
})
